/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalUserOpportunityResponseV3LogoFromJSON, InternalUserOpportunityResponseV3LogoToJSON, } from './InternalUserOpportunityResponseV3Logo';
import { InternalCommonUserBaseFromJSON, InternalCommonUserBaseToJSON, } from './InternalCommonUserBase';
/**
 * @export
 */
export const InternalUserOpportunityResponseV3TypeEnum = {
    Opportunity: 'opportunity'
};
/**
 * Check if a given object implements the InternalUserOpportunityResponseV3 interface.
 */
export function instanceOfInternalUserOpportunityResponseV3(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('title' in value) || value['title'] === undefined)
        return false;
    return true;
}
export function InternalUserOpportunityResponseV3FromJSON(json) {
    return InternalUserOpportunityResponseV3FromJSONTyped(json, false);
}
export function InternalUserOpportunityResponseV3FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'id': json['id'],
        'title': json['title'],
        'content': json['content'] == null ? undefined : json['content'],
        'companyName': json['company_name'] == null ? undefined : json['company_name'],
        'location': json['location'] == null ? undefined : json['location'],
        'logo': json['logo'] == null ? undefined : InternalUserOpportunityResponseV3LogoFromJSON(json['logo']),
        'kindName': json['kind_name'] == null ? undefined : json['kind_name'],
        'user': json['user'] == null ? undefined : InternalCommonUserBaseFromJSON(json['user']),
    };
}
export function InternalUserOpportunityResponseV3ToJSON(json) {
    return InternalUserOpportunityResponseV3ToJSONTyped(json, false);
}
export function InternalUserOpportunityResponseV3ToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'title': value['title'],
        'content': value['content'],
        'company_name': value['companyName'],
        'location': value['location'],
        'logo': InternalUserOpportunityResponseV3LogoToJSON(value['logo']),
        'kind_name': value['kindName'],
        'user': InternalCommonUserBaseToJSON(value['user']),
    };
}
